<template>
<div class="chapter">
<div class="inner_page">
<div>
<p class="ttl" id="c21" style="margin-bottom: 3%;">PART TWO</p>
<p class="ttl2" style="margin-top: 4%;">1856<br/>R<span class="small">OOTS OF</span> S<span class="small">TRIFE</span></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Part_II.vue?00757052